var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { sortByFunc } from '../../../utils/helper/lodash_replacements';
export class ChoiceKeyboardSelect {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get preselectingOption() {
        return this.question.preselectingOption;
    }
    keyboardOptionIndex = undefined;
    get keyboardOption() {
        if (typeof this.keyboardOptionIndex === 'undefined')
            return undefined;
        return this.question.options[this.keyboardOptionIndex];
    }
    set keyboardOption(option) {
        if (!option) {
            this.keyboardOptionIndex = undefined;
        }
        else {
            this.keyboardOptionIndex = option.shuffledOptionIndex;
        }
    }
    get optionsLeftToRight() {
        return this.question.options.concat().sort(sortByFunc(option => option.optionPosition.left));
    }
    get optionsTopToBottom() {
        return this.question.options.concat().sort(sortByFunc(option => option.optionPosition.top));
    }
    initialOption(key) {
        if (key === 'ArrowUp') {
            return this.optionsTopToBottom[this.optionsTopToBottom.length - 1];
        }
        if (key === 'ArrowDown') {
            return this.optionsTopToBottom[0];
        }
        if (key === 'ArrowLeft') {
            return this.optionsLeftToRight[this.optionsLeftToRight.length - 1];
        }
        if (key === 'ArrowRight') {
            return this.optionsLeftToRight[0];
        }
        return undefined;
    }
    get currentPosition() {
        if (this.preselectingOption) {
            return {
                left: this.preselectingOption.inner.aspectMount.measureToWindowIncludingTransform.aspectLeftInPixel,
                top: this.preselectingOption.inner.aspectMount.measureToWindowIncludingTransform.aspectTopInPixel,
            };
        }
    }
    handleArrowKeyPress(key) {
        this.keyboardOption = this.nextKeyboardOption(key);
    }
    nextKeyboardOption(key) {
        if (!this.preselectingOption) {
            return this.initialOption(key);
        }
        const candidates = this.question.options.filter(option => option !== this.keyboardOption);
        let best = this.preselectingOption;
        let best_distance = 99999;
        let isMatchingDirection = false;
        const current = this.preselectingOption.optionPosition;
        for (const option of candidates) {
            const other = {
                left: option.inner.aspectMount.measureToWindowIncludingTransform.aspectLeftInPixel,
                top: option.inner.aspectMount.measureToWindowIncludingTransform.aspectTopInPixel,
            };
            const distY = current.top - other.top;
            const distX = current.left - other.left;
            if (key === 'ArrowUp') {
                isMatchingDirection = distY > 0;
            }
            if (key === 'ArrowDown') {
                isMatchingDirection = distY < 0;
            }
            if (key === 'ArrowLeft') {
                isMatchingDirection = distX > 0;
            }
            if (key === 'ArrowRight') {
                isMatchingDirection = distX < 0;
            }
            const distance = Math.sqrt(distY * distY + distX * distX);
            if (isMatchingDirection && distance < best_distance) {
                best = option;
                best_distance = distance;
            }
        }
        return best;
    }
}
__decorate([
    observable
], ChoiceKeyboardSelect.prototype, "keyboardOptionIndex", void 0);
__decorate([
    computed
], ChoiceKeyboardSelect.prototype, "keyboardOption", null);
__decorate([
    action.bound
], ChoiceKeyboardSelect.prototype, "handleArrowKeyPress", null);
